/* eslint-disable semi,semi-style */
import React, { createContext } from 'react';
// import { Link } from 'react-router-dom'
import { login, logout } from '@/util/login';
import { DownOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Tooltip } from 'antd';
import classNames from 'classnames';
import IconArrow from './down.svg';
import IconUser from './user.svg';
import style from '@/common/scss/header.module.scss';
import { withRouter, Link } from 'react-router-dom';
import { env, urls } from '@/util/env';
import CompanySelect from '../companySelect/CompanySelect';
const navItems = [
  // {
  //   type: "dropDown",
  //   name: "解决方案",
  //   href: "service",
  //   children: [
  //     {
  //       path: "/developer.html#/service/insurance",
  //       name: "设备接入解决方案",
  //       disabled: true,
  //     },
  //     {
  //       path: "/developer.html#/service/purchase",
  //       name: "Unicorn充电桩解决方案",
  //       disabled: true,
  //     },
  //   ],
  // },
  // { href: "/developer.html#/direct", name: "Unicorn OS" },
  
  // {
  //   type: 'dropDown',
  //   name: '设备对接',
  //   href: 'direct',
  //   children: [
  //     { path: '/developer.html#/direct', name: '设备接入' },
  //     { path: '/developer.html#/direct/product-manage', name: '产品管理' },
  //   ],
  // },
  { href: '/developer.html#/direct/directApply', name: '接入工作台' },
  {
    // type: 'dropDown',
    name: '运维工作台',
    href: '/operate.html#/devops',
    // children: [
    //   { path: '/operate.html#/devops', name: '设备监控' },
    //   { path: '/operate.html#/devops/workOrder', name: '设备运维' },
    // ], 
  },

  // {
  //   type: "dropDown",
  //   name: "设备运维",
  //   href: "devops",
  //   children: [
  //     { path: "/operate.html#/devops", name: "运维监控" },
  //     { path: "/operate.html#/devops/workOrder", name: "小桔慧修" },
  //   ],
  // },
  // { href: '/developer.html#/direct/easyPayCapitalAccount', name: '省心付' },
  { href: urls[env] || '', name: '智能桩工作台', target: '_blank' },
];
const getMenu = menuList => (
  <Menu>
    {menuList.map((it, k) => (
      <Menu.Item key={k}>
        {it.disabled ? (
          <Tooltip title="功能开发中，敬请期待">
            <a href="javascript: void(0)">{it.name}</a>
          </Tooltip>
        ) : (
          <a href={it.path}>{it.name}</a>
        )}
      </Menu.Item>
    ))}
  </Menu>
);
const getParents = (node, selector) => {
  const compareNode = document.querySelector(selector);
  const body = document.querySelector('body');
  while (node !== compareNode) {
    node = node.parentNode;
    if (node === body) {
      return false;
    }
  }
  return true;
};

interface companyRole {
  companyId: string;
  roleId: string;
}

export interface UserInfo {
  uid: string;
  duid: string;
  cellphone?: string;
  phone?: string;
  realPhone?: string;
  companyIds: string[];
  companyRoles: companyRole[];
  loginError: boolean;
}

interface HeaderProps {
  user?: UserInfo;
  className?: string;
}

export const UserInfoContext = createContext<UserInfo>(null);

@withRouter
export default class Header extends React.Component<HeaderProps> {
  state = {
    logoHasBg: false,
  };
  
  doLogout = () => {
    localStorage.clear();
    location.href = logout();
  };

  doLogin = () => {
    location.href = login();
  };
  doUserCenter = () => {
    location.href = '/developer.html#/direct/accountInfo';
  };

  doNavChange = (href) => {
    if (href == '/developer.html#/direct/directApply') {
      setTimeout(() => {
        location.reload();
      }, 100);
    }
  }

  doFirstPage= () => {
    location.href = '/';
  };

  toggleMenu = () => {
    const { menu } = this.refs;
    menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
  };

  activeEvent = item => {
    const { location } = this.props;
    const { pathname } = window.location;
    // console.log("pathname", pathname, location);

    if (item.href === '/') {
      return pathname === '/' || pathname === '/index.html';
    }
    // 下拉列表
    if (item.subItem) {
      return location.pathname.indexOf(item.href) !== -1 && location.pathname.indexOf('easyPay') === -1;
    }
    if (item.href === '/developer.html#/' && pathname !== '/' && pathname !== '/index.html') {
      if (location.pathname.indexOf('/devops') === -1 && location.pathname.indexOf('/service') === -1) {
        return true;
      }
      return false;
    }
    const fullPath = pathname + '#' + location.pathname;
    if (fullPath.includes('/direct/account')) return false;
    if (fullPath.includes('easyPay')) return item.href.includes('easyPay');
    if (fullPath.includes('/devops/workOrder')) return item.href.includes('/devops/workOrder');
    return fullPath.indexOf(item.href) !== -1;
  };

  componentDidMount() {
    window.addEventListener('scroll', this.showInk);
    const isDirect = window.location.pathname.includes('developer');
    const isOper = window.location.pathname.includes('operate');
    if ((isDirect || isOper)) {
      this.setState({ logoHasBg: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.showInk);
  }

  showInk = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > 28) {
      if (!this.state.logoHasBg) this.setState({ logoHasBg: true });
    } else {
      const isDirect = window.location.pathname.includes('developer');
      const isOper = window.location.pathname.includes('operate');
      if ((isDirect || isOper)) {
        this.setState({ logoHasBg: true });
      } else {
        if (this.state.logoHasBg) this.setState({ logoHasBg: false });
      }
    }
  };


  render() {
    const { user, className } = this.props;
    const { logoHasBg } = this.state;
    return (
      <header className={classNames(style.header, className, { [style.hasBg]: logoHasBg })}>
        <h1 className={classNames(style.logo, { [style.hasBg]: logoHasBg })} onClick={this.doFirstPage}>滴滴充电</h1>
        <nav className={style.nav}>
          <ul className={style.navList}>
            {/* 原用于首页跳转<li key={0} className={style.navItem}>
              <a
                className={classNames(style.navLink, {
                  [style.active]: this.activeEvent(navItems[0]),
                })}
                href={navItems[0].href}>
                {navItems[0].name}
              </a>
            </li> */}
            {navItems.map((it, i) =>
              it.type === 'dropDown' ? (
                <Dropdown overlay={getMenu(it.children)}>
                  <li className={style.navItem}>
                    <a
                      className={classNames(style.navLink, {
                        [style.active]: this.activeEvent({
                          href: it.href,
                          name: it.name,
                          subItem: true,
                        }),
                        [style.hasBg]: logoHasBg 
                      })}>
                      {it.name} <DownOutlined />
                    </a>
                  </li>
                </Dropdown>
              ) : (
                <li key={i} className={style.navItem}>
                  <a
                    className={classNames(style.navLink, {
                      [style.active]: this.activeEvent(it),
                      [style.hasBg]: logoHasBg 
                    })}
                    href={it.href}
                    onClick={() => this.doNavChange(it.href)}
                    target={it.target}>
                    {it.name}
                  </a>
                </li>
              ),
            )}
          </ul>
        </nav>
        <div className={style.loginArea}>
          {/* <a className="btnLink" href={login}>认证</a> */}
          {/* <a className="btnLink" href={login}>注册</a> */}
          {/* <CompanySelect /> */}
          {user ? (
            <div className={style.layoutUser}>
              <div className={style.selection} onClick={this.toggleMenu}>
                <IconUser className={[style.layoutIcon, style.icon].join(' ')} />
                <span className={style.name}>{user.cellphone || user.phone}</span>
                <IconArrow className={style.layoutIcon} />
              </div>
              <div className={style.menu} ref="menu" style={{ display: 'none' }}>
                <span className={style.menuItem} onClick={this.doUserCenter}>
                  个人中心
                </span>
                {/* <Link className={style.menuItem} to="/direct/testApi/setParams">个人中心</Link> */}
                <span className={style.menuItem} onClick={this.doLogout}>
                  退出
                </span>
              </div>
            </div>
          ) : (
            <a className={[style.btnLink, style.login].join(' ')} onClick={this.doLogin}>
              登录
            </a>
          )}
        </div>
      </header>
    );
  }
}
